import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { REFUND_METHOD } from 'domains/customer-order/constants'
import StringUtil from 'utils/string-util'


const propTypes = {
  method: PropTypes.string
}

const defaultProps = {
  method: 'cash'
}

/**
 * @param {string} method
 */
const CustomerRefundPaymentMethodBadge = ({ method }) => {

  const colorMap = {
    [REFUND_METHOD.CASH]         : 'success',
    [REFUND_METHOD.CREDIT_CARD]  : 'info',
    [REFUND_METHOD.KREDIVO]      : 'warning',
    [REFUND_METHOD.GOPAY]        : 'warning',
    [REFUND_METHOD.VOUCHER_CODE] : 'primary'
  }

  const color = colorMap[method] || 'default'

  return <StatusBadge color={ color } label={ StringUtil.humanize(method) } />
}

CustomerRefundPaymentMethodBadge.propTypes    = propTypes
CustomerRefundPaymentMethodBadge.defaultProps = defaultProps

export default CustomerRefundPaymentMethodBadge
